import React from 'react';
import PropTypes from 'prop-types';
import { get, assign } from 'lodash';
import Collapse from '../elements-collapse/Collapse';
import DiscountRateForm from './forms/DiscountRateForm';
import {
  RevisedCalculator,
  BorderTopLineItem
} from '../elements-forms/line-item-helpers';
import { LineItem } from '../elements-forms/line-item';
import { FormattedMessage } from 'react-intl';

const DiscountRate = ({ listing, ...props }) => {
  const dayRateDiscount = get(listing, 'day_rate_discount', {});
  const value = dayRateDiscount.value || null;
  const initialValues = { day_rate_discount: assign({}, dayRateDiscount, { value }) };

  return (
    <div className="margin-xl-top">
      <h4><FormattedMessage id="hosting.discount_rate.discount_heading" defaultMessage="8+ hour discount (%)"/></h4>
      <p className="text-small text-gray-dark"><FormattedMessage id="hosting.discount_rate.discount_text" defaultMessage="Encourage your guests to book longer by giving a discount for bookings that are 8 hours or more."/></p>
      <div className="clearfix" />
      <div className="row margin-lg-top margin-md-bottom">
        <div className="col-xs-12">
          <DiscountRateForm
            {...props}
            listing={listing}
            initialValues={initialValues}
          />
        </div>
      </div>
      <div className="clearfix" />
      <Collapse
        buttonClassname="btn btn-link no-gutter remove-click-styling"
        buttonText={<FormattedMessage id="hosting.discount_rate.how_is_this_calculated" defaultMessage="How is this calculated?"/>}
      >
        <div className="discount-example-container container-fluid margin-xl-top">
          <div className="row margin-xl-bottom">
            <div className="col-xs-12"><strong><FormattedMessage id="hosting.discount_rate.example" defaultMessage="Example:"/></strong> <FormattedMessage id="hosting.discount_rate.example_text" defaultMessage="If your hourly price is $100, and your discount is 20%"/></div>
          </div>
          <RevisedCalculator>
            <LineItem
              label={{
                content: <FormattedMessage id="hosting.discount_rate.100_8_hours" defaultMessage="$100 x 8 hours"/>
              }}
              value={{}}
              optionalValue={{ amount: 800 }}
              currencyType="USD"
            />
            <LineItem
              label={{
                content: <FormattedMessage id="hosting.discount_rate.20%_discount" defaultMessage="20% discount"/>
              }}
              value={{}}
              optionalValue={{ amount: -160 }}
              currencyType="USD"
            />
            <BorderTopLineItem />
            <LineItem
              label={{ content: <FormattedMessage id="hosting.discount_rate.total" defaultMessage="Total"/> }}
              value={{}}
              optionalValue={{ amount: 640 }}
              customClass="heavy-total margin-sm-top"
              currencyType="USD"
            />
          </RevisedCalculator>
        </div>
      </Collapse>
      <div className="clearfix" />
      <hr />
    </div>
  );
};

DiscountRate.propTypes = {
  listing: PropTypes.object.isRequired
};

export default DiscountRate;
